import React, { useEffect, useState } from "react";
import { getStopActivePassApi } from "../../services/TransportService";
import { Spinner } from "react-bootstrap";
import Pagination from "../Constant/Pagination";
import { Link } from "react-router-dom";
import format from "date-fns/format";
import { toInitials } from "../../utilities";
const StopActivePass = ({ stopid }) => {
  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [total, setTotal] = useState(0);
  const [param, setParam] = useState({
    page: "1",
    page_size: "10",
  });
  useEffect(() => {
    setLoading(true);
    getStopActivePassApi(stopid, param)
      .then((res) => {
        setdata(res?.data?.results?.results || []);
        setTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        setError(err?.response?.data?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [param, stopid]);
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  if (loading) {
    return (
      <div className="text-center my-3">
        <Spinner animation="border" />
      </div>
    );
  }
  if (error) {
    return <div className="alert alert-danger m-2"></div>;
  }
  return (
    <div>
      {data?.length==0 ? (
        <div className="p-2 text-center">There are no records found.</div>
      ) : (
        <div className="table-responsive pb-2">
          <table className="table fs-6 mb-0 align-middle">
            <thead className="custom-thead table-light">
              <tr>
                <th>Employee</th>
                <th>Route No.</th>
                <th>Bus</th>
                <th>Validity</th>
                {/* <th>Inbound Time</th> */}
              </tr>
            </thead>
            <tbody>
              {data?.map((data, index) => {
                const employee = data?.employee;
                // const start = new Date(`1970-01-01T${data.departure_time}`);
                const validity = `${format(
                  new Date(data.start_date),
                  "d MMMM yyyy"
                )} To ${format(new Date(data.end_date), "d MMMM yyyy")}`;

                return (
                  <tr key={index}>
                    <td>
                      <div className="d-flex align-items-center">
                        <div className="me-2">
                          {employee?.profile_photo ? (
                            <img
                              src={`${process.env.REACT_APP_BASE_URL}${employee.profile_photo}`}
                              alt="user"
                              className="rounded-circle"
                              width="36"
                              height="36"
                            />
                          ) : (
                            <div
                              className="rounded-circle bg-dark text-white d-flex justify-content-center align-items-center"
                              style={{
                                width: 36,
                                height: 36,
                                fontSize: "0.875rem",
                              }}
                            >
                              {toInitials(employee?.name)}
                            </div>
                          )}
                        </div>
                        <div>
                          <Link
                            to={`/employee/${employee?.id}`}
                            className="text-uppercase fw-semibold text-primary d-block"
                          >
                            {employee?.name}
                          </Link>
                          <Link
                            to={`/employee/${employee?.id}`}
                            className="text-secondary small d-block"
                          >
                            {employee?.email}
                          </Link>
                        </div>
                      </div>
                    </td>
                    <td><Link to={`/bus/${data?.route?.id}`} className="text-primary cursor-pointer fw-semibold">{data.route?.route_number || "-"}</Link></td>
                    <td><Link to={`/bus/${data?.bus?.id}`} className="text-primary cursor-pointer fw-semibold">{data.bus?.number_plate || "N/A"}</Link></td>
                    <td>{validity}</td>
                    {/* <td>{format(start, "h.mm a")}</td> */}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      {!loading && data?.length > 0 && (
        <div className="border-top px-2">
          <Pagination
            currentPage={param.page}
            recordsPage={param.page_size}
            dataLength={total}
            handlePagination={handlePageChange}
          />
        </div>
      )}
    </div>
  );
};

export default StopActivePass;
